import * as React from 'react'
import { MenuListProps, components } from 'react-select'
import { UserOption } from '../user-select.types'

export const MenuList = (props: MenuListProps<UserOption>) => (
  <components.MenuList {...props} className="py-0" />
)
